import { Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import ProjectDetails from "./pages/ProjectDetails";
import Login from "./pages/Login";
import AdminApp from "./pages/AdminApp";
import UATProjects from "./pages/UATProjects";
import LangSmithDashboard from "./pages/LangSmithDashboard";
import FirefoxExtensionInstall from "./pages/FirefoxExtensionInstall";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminRoute from "./components/AdminRoute";
import SuperAdminRoute from "./components/SuperAdminRoute";
import { AuthProvider, useAuth } from "./context/AuthProvider";
import PortalLayout from "./components/portal/PortalLayout";
import UrlSunsetWarning, {
  isLegacyHost,
  isLegacyUrlExpired,
} from "./components/UrlSunsetWarning";
// import ProjectDashboard from "./pages/ProjectDashboard";

function AppContent() {
  const { user, loading } = useAuth();
  return (
    <>
      {!loading && (
        <Routes>
          {/* 🔒 Protected Routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <PortalLayout>
                  <Home />
                </PortalLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/project/:id"
            element={
              <ProtectedRoute>
                <PortalLayout>
                  <ProjectDetails />
                </PortalLayout>
              </ProtectedRoute>
            }
          />

          {/* Public Login Route */}
          <Route path="/auth/login" element={!user ? <Login /> : <Navigate to="/" />} />

          {/* Public - Firefox extension installer */}
          <Route
            path="/install/firefox"
            element={
              <PortalLayout>
                <FirefoxExtensionInstall />
              </PortalLayout>
            }
          />

          {/* 🔒 Admin Only - UAT Projects */}
          <Route
            path="/uat"
            element={
              <AdminRoute>
                <PortalLayout>
                  <UATProjects />
                </PortalLayout>
              </AdminRoute>
            }
          />

          <Route
            path="/langsmith"
            element={
              <SuperAdminRoute>
                <PortalLayout>
                  <LangSmithDashboard />
                </PortalLayout>
              </SuperAdminRoute>
            }
          />

          {/* 🔒 Admin Only */}
          <Route
            path="/admin/*"
            element={
              <AdminRoute>
                <PortalLayout>
                  <AdminApp />
                </PortalLayout>
              </AdminRoute>
            }
          />
        </Routes>
      )}
    </>
  );
}

function App() {
  const legacyOff = isLegacyHost() && isLegacyUrlExpired();
  return (
    <AuthProvider>
      <UrlSunsetWarning />
      {!legacyOff && <AppContent />}
    </AuthProvider>
  );
}

export default App;
